import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';
import { TenantDTO } from '../domain/tenant';

export class ColloquioConoscitivoDTO extends LogicalDeleteDTO{
    id: number;
    tenant: TenantDTO;
    nome: string;
    cognome: string;
    numTelefono: string;
    email: string;
    istruzione: string;
    votoIstruzione: number;
    descrizione: string;
    voto: number;
    votoQuiz: number;
    votoSpigliatezza: number;
    votoComprensione: number;
    votoLogica: number;
    dataColloquio: Date;
}